import { createDefault } from "../utils/ConstUtils";

export default createDefault([
  { value: 1, text: "良品", enum: "GOOD" },
  { value: 2, text: "不良品", enum: "BAD" },
  { value: 3, text: "委託品", enum: "CONSIGNMENT", hidden: true },
  { value: 4, text: "消化仕入品", enum: "BUYINGSALES", hidden: true },
]);
